export const PROMOTION_TYPE_FREE_PLAN = 'FreePlan';
export const PROMOTION_TYPE_ANGHAMI = 'ANGHAMI';
export const PROMOTION_TYPE_STARZPLAY = 'STARZPLAY';
export const ANGHAMI_PROMOTION = 'ANGHAMI_PROMOTION';
export const STARZPLAY_PROMOTION = 'STARZPLAY_PROMOTION';
export const PROMOTION_TYPE_DATA_SOCIAL = 'DATA-SOCIAL';
export const PROMOTION_TYPE_VOICE_ON_NET = 'VOICE-ON-NET';
export const CONTENT_SERVICE_TYPE='ContentServiceType';
export const PROMOTION_TYPE_VOICE_LCL = 'VOICE-LCL'
export const PROMOTION_TYPE_VOICE_INT = 'VOICE-INT'
export const PROMOTION_TYPE_DATA = 'DATA';
export const PROMOTION_TYPE_SMS = "SMS-LCL";
export const PROMOTION_TYPE_DATA_ROM = "DATA-ROM";
export const PROMOTION_TYPE_DISCOUNT = 'PercentDiscount';
export const PROMOTION_TYPE_AMOUNT_DISCOUNT = 'AmountDiscount';
export const SAUDI_ID = 'S';
export const BLUTV_PROMOTION = 'BLUTV_PROMOTION';
export const ARROW_ACTION_UP = "up"
export const ARROW_ACTION_DOWN = "down"
export const SCROLLER_ANIMATION_DURATION = 300
export const INTERNATIONAL_INIT_CODE = "966"
export const PROMOTION_TYPE_OSN = 'OSN';
export const PROMOTION_TYPE_UFC = 'UFC';
export const PROMOTION_TYPE_DISCOVERY = 'Discovery';
export const PROMOTION_TYPE_BLUTV = 'BluTV';
export const OSN_PROMOTION = 'OSN_PROMOTION';
export const UFC_PROMOTION = 'UFC_PROMOTION';
export const DISCOVERY_PROMOTION = 'DISCOVERY_PROMOTION';
